// extracted by mini-css-extract-plugin
export default {"formWrapper":"_Form_formWrapper__gUFo8","formHeader":"_Form_formHeader__QRFpl","formContainer":"_Form_formContainer__OzVU4"};